export const SET_SENDER_COUNTRY_FIELD = 'SET_SENDER_COUNTRY_FIELD';
